<app-base-auth>
  <ng-container *ngIf="mode === 'reset' && !result.show">
    <div style="text-align: left; padding: 20px 2px; font-weight: 600">
      {{ "Please enter a new password" | locale }}
    </div>
    <div class="login-form">
      <nz-form-item>
        <p class="input-title">
          {{ "New Password" | locale }}
        </p>
        <nz-input-group [nzSuffix]="showPasswordTemplate" class="border-radius">
          <input
            [type]="passwordVisible ? 'text' : 'password'"
            type="password"
            nz-input
            class="border-radius"
            #PasswordControl
            [placeholder]="'Password' | locale"
            [(ngModel)]="Password"
          />
        </nz-input-group>
        <ng-template #showPasswordTemplate>
          <span
            nz-icon
            [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
            (click)="passwordVisible = !passwordVisible"
          ></span>
        </ng-template>
      </nz-form-item>
      <button
        nz-button
        nzSize="large"
        class="form-button border-radius"
        nzType="primary"
        (click)="resetPassowrd()"
      >
        {{ "Reset my password" | locale }}
      </button>
      <small>
        reset password for the email:<br />
        {{ email }}
      </small>
    </div>
  </ng-container>
  <ng-container *ngIf="mode === 'request' && !result.show">
    <div style="text-align: left; padding: 20px 2px; font-weight: 600">
      {{ "Please enter your email to get reset password email" | locale }}
    </div>
    <div class="login-form">
      <nz-form-item>
        <p class="input-title">
          {{ "email" | locale }}
        </p>
        <input
          type="email"
          nz-input
          class="border-radius"
          [placeholder]="'e.g. james.mikael@itm-development.com'"
          [(ngModel)]="email"
        />
      </nz-form-item>
      <button
        nz-button
        nzSize="large"
        class="form-button border-radius"
        nzType="primary"
        (click)="sendResetRequest()"
      >
        {{ "Reset my password" | locale }}
      </button>
      

      <button
      *ngIf="!result.show"
      nz-button
      nzSize="large"
      class="go-to-login-btn"
      nzType="primary"
      [routerLink]="['/auth/login']"
    >
      {{ "Go to Back" | locale }}

    </button>
    </div>
  </ng-container>
  <nz-result
    *ngIf="result.show"
    nzStatus="success"
    [nzTitle]="result.title"
    [nzSubTitle]="result.subTitle"
  >

    <div nz-result-extra>
      <button [routerLink]="['/auth/login']" nz-button nzType="primary">
        Go to login
      </button>
    </div>
  </nz-result>


</app-base-auth>
